import React from 'react';
import FilterTime from './FilterTime';
import Table from './Table';
import Const from '../Const';
import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  fetchListDataTable,
  fetchInfoTicker,
  changeCode,
} from '../reducer';
import InforIndex from './InforIndex';
import TimeFrame from './TimeFrame';
import {
  getCodeFromQuery,
  getQueryParams,
  isTicker,
} from '../../../helpers/Common';
import Footer from './../../../common/table/Footer';
import { compose } from 'redux';
import { withComponentId } from './../../../common/ComponentIdContext';
import Export from './Export';
import LockedDiv from '../../../common/locked-div/LockedDiv';

class TabContent extends React.Component {
  constructor(props) {
    super(props);
    const { changeCode, componentId } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock', 'index']);
    if (codeFromQuery) {
      changeCode(codeFromQuery, componentId);
    }
  }

  componentDidMount() {
    const { fetchInfoTicker, fetchListDataTable, componentId } = this.props;
    if (!getQueryParams('code')) {
      fetchInfoTicker(componentId);
      fetchListDataTable(componentId);
    }
  }

  getHideColumns = () => {
    const { indexSumary } = this.props;

    return isTicker(indexSumary)
      ? []
      : [Const.priceDataTableOverview.AVERAGE_PRICE];
  };

  getSchemaKey = () => {
    const { currentTab } = this.props;
    const map = {
      [Const.tabs.overview]: Const.priceDataTableOverview,
      [Const.tabs.orderStatistic]: Const.priceDataTableOrderStatistic,
      [Const.tabs.properietary]: Const.priceDataTableProprietary,
      [Const.tabs.foreign]: Const.priceDataTableForeign,
    };

    return map[currentTab];
  };

  getTableTitle = () => {
    const { currentTab } = this.props;
    const mapTitle = {
      [Const.tabs.overview]: 'priceData.priceDataTableOverview',
      [Const.tabs.orderStatistic]: 'priceData.priceDataTableOrderStatistic',
      [Const.tabs.properietary]: 'priceData.priceDataTableProprietary',
      [Const.tabs.foreign]: 'priceData.priceDataTableForeign',
    };

    return mapTitle[currentTab];
  };

  render() {
    const hideColumns = this.getHideColumns();
    const schemaKey = this.getSchemaKey();

    const footerText =
      this.getTableTitle() === 'priceData.priceDataTableOverview'
        ? 'priceData.footerText1'
        : 'priceData.footerText2';

    const { componentId, currentTab } = this.props;

    return (
      <>
        <div className="pd-price-data-wrapper flex-fill d-flex flex-column flex-shrink-0">
          <div className="pd-top-navigation--left mb-10 flex-shrink-0">
            <InforIndex />
          </div>
          <div className="pd-top-navigation mb-10 flex-shrink-0">
            <div
              className="pd-top-navigation--left list-filter"
              style={{ width: 'auto' }}
            >
              <FilterTime />
              <TimeFrame />
            </div>
            <LockedDiv>
              <Export currentTab={currentTab} id={componentId} />
            </LockedDiv>
          </div>

          <Table
            hideColumns={hideColumns}
            title={this.getTableTitle()}
            schemaKey={schemaKey}
            id={componentId}
          />
        </div>
        <Footer listTextLang={[{ text: footerText }]} />
      </>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    indexSumary:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumary,
  };
};

const mapDispatchToProps = {
  fetchInfoTicker,
  fetchListDataTable,
  changeCode,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TabContent);
